import api from './api';

const videoService = {
  // Video Category related
  getAllVideoCategory: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    return api.get(`/admin/video_category?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`);
  },
  
  getSingleVideoCategory: (vcId) => {
    return api.get(`/admin/video_category/${vcId}`);
  },
  
  addVideoCategory: (payload) => {
    return api.post('/admin/video_category/', payload);
  },
  
  editVideoCategory: (vcId, payload) => {
    return api.put(`/admin/video_category/${vcId}`, payload);
  },
  
  updateVideoCategoryOrder: (payload) => {
    return api.put('/admin/video_category_order', payload);
  },
  
  // Video Quality related
  getAllVideoQuality: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    return api.get(`/admin/video_quality?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`);
  },
  
  getSingleVideoQuality: (vqId) => {
    return api.get(`/admin/video_quality/${vqId}`);
  },
  
  addVideoQuality: (payload) => {
    return api.post('/admin/video_quality/', payload);
  },
  
  editVideoQuality: (vqId, payload) => {
    return api.put(`/admin/video_quality/${vqId}`, payload);
  },
  
  updateVideoQualityOrder: (payload) => {
    return api.put('/admin/video_quality_order', payload);
  },
  
  // Video Language related
  getAllVideoLanguage: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    return api.get(`/admin/languages?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`);
  },
  
  getSingleVideoLanguage: (langId) => {
    return api.get(`/admin/languages/${langId}`);
  },
  
  addVideoLanguage: (payload) => {
    return api.post('/admin/languages/', payload);
  },
  
  editVideoLanguage: (langId, payload) => {
    return api.post(`/admin/languages/update/${langId}`, payload);
  },

  // Video Show related
  getAllVideoShow: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    return api.get(`/admin/video_show?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`);
  },
  
  getSingleVideoShow: (videoShowId) => {
    return api.get(`/admin/video_show/${videoShowId}`);
  },
  
  addVideoShow: (payload) => {
    return api.post('/admin/video_show/', payload);
  },
  
  editVideoShow: (videoShowId, payload) => {
    return api.put(`/admin/video_show/${videoShowId}`, payload);
  },

  // Video Ratings related
  getAllVideoRatings: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    return api.get(`/admin/video_rating?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`);
  },
  
  getSingleVideoRating: (vrId) => {
    return api.get(`/admin/video_rating/${vrId}`);
  },
  
  addVideoRating: (payload) => {
    return api.post('/admin/video_rating/', payload);
  },
  
  editVideoRating: (vrId, payload) => {
    return api.put(`/admin/video_rating/${vrId}`, payload);
  },

  // Upload related
  getUploadUrl: () => {
    return api.get('/admin/get-upload-url');
  },
  
  getSrtUploadUrl: () => {
    return api.get('/admin/subtitles/upload');
  },
  
  uploadVideoToS3: (payload) => {
    return api.post('/admin/upload-video', payload);
  }
};

export default videoService;
